import type { AsyncThunkApiConfig } from '@/store'
import type { RejectError } from '../../typings'

import { createAsyncThunk } from '@reduxjs/toolkit'

export const updateRoadSegment = createAsyncThunk<
  // Return type of the payload creator
  void,
  // First argument to the payload creator
  uui.domain.ui.forms.RoadSegmentUpdate,
  // thunk API
  AsyncThunkApiConfig<RejectError>
>('domain/roadSegment/update', async (payload, thunkApi) => {
  try {
    const rpc = thunkApi.extra.domainProxy.getRpc()

    const response = await rpc('rpc/roadSegment/update', {
      category: 'rpc',
      type: 'rpc/roadSegment/update',
      roadSegment: payload,
    })

    if (response.type === 'rpc-failure') {
      return thunkApi.rejectWithValue({
        type: 'rpcFailure',
        message: response.errorMessage,
        error: response,
      })
    }
  } catch (error) {
    thunkApi.extra.journal.main(
      `Unknown error on {update}`,
      { tags: ['rpc', 'roadSegment'], info: payload },
      'error',
    )

    return thunkApi.rejectWithValue({
      type: 'unknown',
      message: `Update Road Segment failed`,
      error,
    })
  }
})
